import { Child, Container, Title } from '../components/Heading';
import { logout } from '../text';

export const Logout = () => {
	return (
		<Container container>
			<Child>
				<Title>{logout.title}</Title>
			</Child>
		</Container>
	);
};
